module.exports = __webpack_public_path__ + "media/assets/icons/relaxed_icon-0f40c1ff6490659db6d1d58b1fbc744b.svg";